import type { DateRange } from 'components/filter/input/DateRangePicker/types';
import { TimeGranularity } from 'services/data.service';
import { differenceInDays, differenceInMonths } from 'date-fns';

export const calculateGranularity = (dateRange: DateRange): TimeGranularity => {
  if (dateRange) {
    const from = dateRange.from ?? new Date();
    const to = dateRange.to ?? new Date();
    if (differenceInMonths(to, from) > 24) {
      return TimeGranularity.YEAR;
    }
    const days = differenceInDays(to, from);
    if (days > 91) {
      return TimeGranularity.MONTH;
    }
    if (days > 31) {
      return TimeGranularity.WEEK;
    }
  }

  return TimeGranularity.DAY;
};
